import React, { useContext, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Utils from "../Utils";
import LeftNavigation from "./left.navigation/LeftNavigation";
import SiteLeftNavigation from "./left.navigation/SiteLeftNavigation";
import SitePage from "./content.area/sites/SitePage";
import ContentArea from "./content.area/ContentArea";
import ContextComponent from "../AppContext";
import ProjectLeftNavigation from "./left.navigation/ProjectLeftNavigation";

const Body = () => {
  // let sitePath =
  //   Utils.APP_URLS.SITE_PAGE.replace(Utils.APP_URLS.SITES_PAGE, "") + "/*";
  let projectPath = Utils.APP_URLS.PROJECT_SITE_PAGE + "/*";
  let {
    setFolderStructure,
    setLoadingState,
    setCanRedirectToLogin,
    setVirtualFolderData,
  } = useContext(ContextComponent);

  const findParentId = (tree, targetId, parentId = null) => {
    for (const node of tree) {
      if (node.id === targetId) {
        return parentId;
      }

      if (node.children?.length) {
        const result = findParentId(node.children, targetId, node.id);
        if (result !== null) return result;
      }
    }

    return null;
  };

  const success = (res) => {
    const allFolders = res.data;
    const virtualFolder = [
      {
        id: Utils.VIRTUAL_FOLDER_NAME,
        name: "Root",
        path: "/Root",
        children: allFolders,
      },
    ];
    const buildTreeData = (items) => {
      return items.map((item) => ({
        id: item.id,
        name: item.name,
        path: item.path,
        parentId: findParentId(allFolders, item.id),
        children: item.children?.length ? buildTreeData(item.children) : [],
      }));
    };
    const treeData = buildTreeData(allFolders);
    const virtualData = buildTreeData(virtualFolder);
    setVirtualFolderData(virtualData);
    setFolderStructure(treeData);
  };

  const fail = (err) => {
    setLoadingState({
      applyMask: false,
    });
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  const loadAllFolders = () => {
    Utils.getAllFolders().then(success, fail);
  };

  useEffect(() => {
    loadAllFolders();
  }, []);

  return (
    <>
      <div className="indi-body-wrapper container ">
        <div className="indi-body-row h-100">
          <div className="row h-100">
            <div className="col col-lg-3 col-md-4 col-sm-5 col-xs-12 indi-full-height">
              <Routes>
                {/* <Route
                  path={sitePath}
                  exact
                  element={<SiteLeftNavigation />}
                ></Route> */}
                <Route
                  path={projectPath}
                  exact
                  element={<ProjectLeftNavigation />}
                ></Route>
                <Route path={`*`} element={<LeftNavigation />}></Route>
              </Routes>
            </div>
            <div className="col col-lg-9 col-md-8 col-sm-7 col-xs-12 indi-full-height">
              <div className="indi-content-area-wrapper d-flex h-100">
                <Routes>
                  {/* <Route path={sitePath} exact element={<SitePage />}></Route> */}
                  <Route
                    path={projectPath}
                    exact
                    element={<SitePage />}
                  ></Route>
                  <Route path={`*`} element={<ContentArea />}></Route>
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Body;
